import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { AnaliseDeRiscoCliente } from '../domain/analise-de-risco-cliente.model';

export class AnaliseDeRiscoClienteSerializer extends DomainSerializer<AnaliseDeRiscoCliente> {}
